<!--
 * @Description: 项目调研 5
 * @Date: 2022-06-27 10:50:51
-->
<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="210px"
      class="ruleForm"
    >
      <submit-result
        :auditList="addEditMixin_auditList"
        noPassRemark="请继续编辑项目信息或调研问卷的选项"
        :projectStatus="ruleForm.projectStatus"
      ></submit-result>
      <div class="xrk-project-form">
        <div class="left">
          <div>
            <xrk-subtitle>项目信息</xrk-subtitle>
            <el-form-item label="项目编码：" prop="projectName">
              <el-input v-model.trim="ruleForm.projectNo" disabled></el-input>
              <el-button
                type="primary"
                class="copyBtn_1"
                :data-clipboard-text="ruleForm.projectNo"
                @click="$copy('copyBtn_1')"
              >
                复制
              </el-button>
            </el-form-item>
            <el-form-item
              label="客户企业："
              prop="industryEnterpriseId"
              v-if="hasIndustry || penetratingDisplay != -1"
            >
              <el-tooltip
                effect="dark"
                :content="ruleForm.industryEnterpriseName"
                placement="top"
              >
                <el-input
                  disabled
                  :value="ruleForm.industryEnterpriseName"
                  v-if="hasIndustry || penetratingDisplay != -1"
                ></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="项目名称：" prop="projectName">
              <el-input v-model.trim="ruleForm.projectName" disabled></el-input>
            </el-form-item>
            <el-form-item
              label="项目简介："
              prop="introduction"
              class="absoluteBox"
            >
              <el-input
                type="textarea"
                v-model.trim="ruleForm.introduction"
                placeholder="请输入项目简介"
                :rows="7"
                style="width:300px;"
                maxlength="200"
                :show-word-limit="true"
                :disabled="addEditMixin_introductionDisbaled"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="项目结算单价（不含税）："
              v-if="hasIndustry"
              prop="price"
            >
              <el-input
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.price"
              ></el-input>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
            <el-form-item label="终端结算单价：" prop="csoPrice">
              <el-input
                :disabled="addEditMixin_disbaled"
                v-model.trim="ruleForm.csoPrice"
                :maxlength="11"
              ></el-input>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
            <el-form-item
              label="税率："
              v-if="hasIndustry"
              prop="contractScale"
            >
              <el-input
                :disabled="addEditMixin_disbaled"
                v-model.trim="ruleForm.contractScale"
              ></el-input>
              <span style="margin-left:10px;">%</span>
            </el-form-item>
            <el-form-item label="总任务量：" prop="taskSumCount">
              <el-input disabled :value="ruleForm.taskSumCount || 0"></el-input>
            </el-form-item>
            <el-form-item label="已完成任务量：">
              <el-input
                disabled
                :value="ruleForm.finishSumCount || 0"
              ></el-input>
            </el-form-item>
            <!-- 项目支付通道 -->
            <pay-channel />
          </div>

          <div style="margin-top:50px">
            <xrk-subtitle>项目执行要求</xrk-subtitle>

            <el-form-item label="背景需求：" prop="projectBackground">
              <el-select
                v-model="ruleForm.projectBackground"
                :disabled="addEditMixin_disbaled"
                placeholder="请选择背景"
                @change="addEditMixin_validateBackground"
              >
                <el-option
                  v-for="item in addEditMixin_backgroundList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="审核人员对其可见：">
              <reviewer
                :disabled="addEditMixin_disbaled"
                :info="ruleForm"
              ></reviewer>
            </el-form-item>
            <!--1 项目执行人脱敏规则：-->
            <tm-execute-name-rule
              v-model="ruleForm.tmExecuteNameRule"
              :disabled="addEditMixin_disbaled"
            />
            <el-form-item
              v-for="(ele, i) in addEditMixin_formItems"
              :label="ele.label"
              :key="i"
              :prop="ele.prop"
              :rules="ele.rule"
            >
              <el-input
                v-model="ruleForm[ele.prop]"
                :disabled="addEditMixin_disbaled"
                v-bind="ele"
              >
                <template #append>
                  {{ ele.suffix }}
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" v-html="ele.content"></div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="上传图片方式：" prop="picUploadRule">
              <el-checkbox
                style="z-index: 0;"
                v-model="photoRule.photoGraph"
                :disabled="addEditMixin_disbaled"
                label="拍照"
              ></el-checkbox>
              <el-checkbox
                style="z-index: 0;"
                v-model="photoRule.photoLibrary"
                :disabled="addEditMixin_disbaled"
                label="照片图库"
              ></el-checkbox>
            </el-form-item>
            <el-form-item label="职业认证：" prop="isOccupationAuth">
              <el-radio-group
                v-model="ruleForm.isOccupationAuth"
                :disabled="addEditMixin_disbaled"
              >
                <el-radio
                  border
                  class="auth-type"
                  :label="item.type"
                  v-for="(item, index) in isOccupationAuthArray"
                  :key="`way${index}`"
                >
                  {{ item.value }}
                </el-radio>
              </el-radio-group>
              <div
                v-if="ruleForm.isOccupationAuth"
                class="is-occupation-auth"
                style="display:flex;margin-top:20px"
              >
                <div>
                  <el-form-item
                    label-width="100px"
                    label="认证类型："
                    prop="occupationType"
                  >
                    <!-- <span>认证类型：</span> -->
                    <span>
                      <el-select
                        style="width:30%"
                        v-model="ruleForm.occupationType"
                        :disabled="addEditMixin_disbaled"
                        placeholder="请选择认证类型"
                      >
                        <el-option
                          v-for="item in occupationTypeArray"
                          :key="item.id"
                          :value="item.id"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </span>
                  </el-form-item>
                </div>
                <div style="margin-left:20px">
                  <el-form-item label-width="0" prop="occupationAuthMode">
                    <el-radio-group
                      v-model="ruleForm.occupationAuthMode"
                      :disabled="addEditMixin_disbaled"
                    >
                      <el-radio
                        border
                        class="auth-type"
                        :label="item.type"
                        v-for="(item, index) in occupationAuthModeArray"
                        :key="`way${index}`"
                      >
                        {{ item.value }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="C端图片查重："
              v-if="addEditMixin_repeatFormItemEnabled"
              prop="isCPicRepeat"
            >
              <el-radio-group
                v-model="ruleForm.isCPicRepeat"
                :disabled="addEditMixin_disbaled"
              >
                <el-radio border class="auth-type" :label="1">
                  是
                </el-radio>
                <el-radio border class="auth-type" :label="0">
                  否
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <!--3 姓名题 -->
            <template v-if="+ruleForm.isQuesNameRule === 1">
              <!-- 输入类型 -->
              <el-form-item label="姓名题输入类型：" prop="tmQuesNameType">
                <el-radio-group
                  v-model="ruleForm.tmQuesNameType"
                  :disabled="addEditMixin_disbaled"
                >
                  <el-radio border :label="1">中文</el-radio>
                  <el-radio border :label="2">英文</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 输入规则 -->
              <el-form-item
                v-if="+ruleForm.tmQuesNameType == 1"
                label="姓名题脱敏规则："
                required
                prop="tmQuesNameRule"
              >
                <el-radio-group v-model="tmForm.tmQuesNameRule1">
                  <el-radio :label="1" :disabled="addEditMixin_disbaled">
                    部分隐藏
                    <span style="color:rgb(177, 177, 177)">例：王*二</span>
                  </el-radio>
                  <el-radio :label="2" :disabled="addEditMixin_disbaled">
                    字母缩写
                    <span style="color:rgb(177, 177, 177)">例：WZS</span>
                  </el-radio>
                  <el-radio :label="3" :disabled="addEditMixin_disbaled">
                    CRF 四字缩写
                  </el-radio>
                  <el-tooltip
                    effect="dark"
                    placement="top-end"
                    style="transform: translateX(-25px)"
                  >
                    <div slot="content">
                      <p>
                        两字姓名取拼音前2个字母（张三ZHSA）；
                        三字姓名取三字首字母及第三字第二
                      </p>
                      <p>
                        字母（李思思LSSI）；四字姓名取每字首字母（欧阳晓倩OYXQ）；
                        姓名全拼不
                      </p>
                      <p>足4个字母，双写第3个字母（安娥ANEE）</p>
                    </div>
                    <el-button
                      type="text"
                      icon="el-icon-warning-outline"
                    ></el-button>
                  </el-tooltip>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="+ruleForm.tmQuesNameType == 2"
                label="姓名题脱敏规则："
                required
                prop="tmQuesNameRule"
              >
                <el-radio-group v-model="tmForm.tmQuesNameRule2">
                  <el-radio :label="3" :disabled="addEditMixin_disbaled">
                    CRF四字缩写
                  </el-radio>
                  <el-tooltip
                    effect="dark"
                    placement="top-end"
                    style="transform: translateX(-25px);"
                  >
                    <div slot="content">
                      <p>
                        两字姓名取拼音前2个字母（张三ZHSA）；
                        三字姓名取三字首字母及第三字第二
                      </p>
                      <p>
                        字母（李思思LSSI）；四字姓名取每字首字母（欧阳晓倩OYXQ）；
                        姓名全拼不
                      </p>
                      <p>足4个字母，双写第3个字母（安娥ANEE）</p>
                    </div>
                    <el-button
                      type="text"
                      icon="el-icon-warning-outline"
                    ></el-button>
                  </el-tooltip>
                  <el-radio :label="4" :disabled="addEditMixin_disbaled">
                    不处理
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
            <el-form-item
              label="订单支付审核："
              v-if="ruleForm.isOrderAudit == 1"
            >
              <el-button
                plain
                style="color: #3a8ee6;border-color: #3a8ee6;cursor: default;"
              >
                需审核
              </el-button>
              <span>
                项目支付给自然人时需进行审核
              </span>
            </el-form-item>
            <el-form-item
              label="任务提交时间显示："
              style="width: 500px
              ;"
            >
              <el-radio
                disabled
                v-model="TaskSubmissionTimeisDisplayed.isTaskSubmitTime"
                :label="0"
              >
                不显示
              </el-radio>
              <el-radio
                disabled
                v-model="TaskSubmissionTimeisDisplayed.isTaskSubmitTime"
                :label="1"
              >
                显示
              </el-radio>
              <div
                v-if="TaskSubmissionTimeisDisplayed.isTaskSubmitTime == 1"
                style="display: flex; margin-top: 20px;margin-bottom: 20px;"
              >
                <el-checkbox
                  v-model="
                    TaskSubmissionTimeisDisplayed.projectExtendQues.industry
                  "
                  :true-label="1"
                  :false-label="0"
                  disabled
                  style="margin-right: 0;"
                  label="工业"
                  border
                ></el-checkbox>
                <el-checkbox
                  v-model="TaskSubmissionTimeisDisplayed.projectExtendQues.cso"
                  disabled
                  :true-label="1"
                  :false-label="0"
                  style="margin-right: 0;"
                  label="服务商"
                  border
                ></el-checkbox>
                <el-checkbox
                  v-model="TaskSubmissionTimeisDisplayed.projectExtendQues.oss"
                  disabled
                  :true-label="1"
                  :false-label="0"
                  style="margin-right: 0;"
                  label="后台"
                  border
                ></el-checkbox>
              </div>
              <div
                v-if="TaskSubmissionTimeisDisplayed.isTaskSubmitTime == 1"
                style="display: flex;font-size: 12px;"
              >
                <p>显示格式：</p>
                <el-select
                  disabled
                  style="width: 50px;"
                  v-model="
                    TaskSubmissionTimeisDisplayed.projectExtendQues
                      .showFormatTime
                  "
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in displayFormat"
                    :label="item.label"
                    :value="item.value"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="是否需要执行人上传资质证明：">
              <el-radio
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.isNeedCertification"
                :label="1"
              >
                需要
              </el-radio>
              <el-radio
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.isNeedCertification"
                :label="0"
              >
                不需要
              </el-radio>
            </el-form-item>
            <updateQualificationProof
              :disabled="addEditMixin_disbaled"
              v-model="ruleForm.certificationClassifyList"
              @selectOptionsDataEvent="selectOptionsDataEvent"
              v-if="ruleForm.isNeedCertification === 1"
            ></updateQualificationProof>
          </div>
        </div>
        <div>
          <xrk-subtitle>需求信息</xrk-subtitle>
          <el-form-item label="封面图：" prop="bgUrl">
            <GenerateImage
              :initUrl="ruleForm.bgUrl"
              :oldUrl="ruleForm.oldBgUrl"
              :initType="ruleForm.bgUrlSource"
              @done="addEditMixin_finishUpload"
              @finish="addEditMixin_finishUpload"
              @changeType="addEditMixin_changeBgType"
              :auditStatus="ruleForm.auditStatus"
              :disabled="addEditMixin_disbaled"
            ></GenerateImage>
          </el-form-item>
          <el-form-item :label="`${sonProjectName || '调研'}问卷：`">
            <div>
              <el-button
                type="primary"
                @click="toQuestion"
                :disabled="addEditMixin_disbaled"
              >
                问卷编辑
              </el-button>
              <el-button type="warning" @click="openPreview">
                问卷预览
              </el-button>
              <div
                style="display: inline-block;margin-left:10px;"
                v-amplifyImg="$getQrcodeUrl('https:' + surveyUrl)"
                :src="$getQrcodeUrl('https:' + surveyUrl)"
              >
                <img :src="require('@/assets/img/ewm.svg')" alt />
              </div>
            </div>
            <div>
              <el-input
                disabled
                :value="ruleForm.questionnaireTitle"
                placeholder="问卷标题"
                style="display:block;margin-top:22px"
              ></el-input>
              <div>
                <el-input
                  disabled
                  :placeholder="`问卷链接：${surveyUrl}`"
                  style="margin-top:23px"
                ></el-input>
                <el-button
                  type="success"
                  class="copyBtn"
                  :data-clipboard-text="`https:${surveyUrl}`"
                  @click="addEditMixin_copy"
                >
                  复制链接
                </el-button>
              </div>
            </div>
            <div>
              问卷相似度：
              <span style="color:#67C23A;" v-if="reportValue <= 0.3">低</span>
              <span style="color:#E6A23C;" v-else-if="reportValue <= 0.5">
                中
              </span>
              <span style="color:#EF324E;" v-else-if="reportValue <= 1">
                高
              </span>
            </div>
          </el-form-item>
          <el-form-item
            label="问卷收集方式："
            required
            v-if="ruleForm.collectionType > 0"
          >
            <el-radio-group :value="1" :disabled="true">
              <el-radio border class="auth-type" :label="1">
                {{
                  { 1: '自行提交', 2: '分享收集', 3: '自行提交+分享收集' }[
                    ruleForm.collectionType
                  ]
                }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
      <div class="xrk-project-footer">
        <template v-if="addEditMixin_showSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_submitForm('ruleForm')"
            :loading="btLoading"
            :disabled="addEditMixin_disbaled"
          >
            保存
          </el-button>
          <submit-verify-btn
            @finish="finishSubmitFn"
            :auditStatus="ruleForm.auditStatus"
            :ifDis="addEditMixin_disbaled"
          ></submit-verify-btn>
        </template>
        <el-button
          type="primary"
          plain
          v-if="addEditMixin_showAginEditBtn"
          @click="addEditMixin_onAginEditProject(ruleForm)"
          :loading="btLoading"
          :disabled="addEditMixin_aginEditBtnDisabled"
        >
          再次编辑
        </el-button>
        <template v-if="addEditMixin_showAginSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_cancelEditProject('ruleForm')"
          >
            取消
          </el-button>
          <el-button
            type="primary"
            plain
            @click="addEditMixin_confirmEditProject('ruleForm')"
            :loading="btLoading"
          >
            提交审核
          </el-button>
        </template>
        <submit-verify-and-next-btn
          :info="ruleForm"
          :submitFn="finishSubmitFn"
          ref="submitVerifyAndNextBtn"
        ></submit-verify-and-next-btn>
      </div>
    </el-form>
    <el-dialog title="预览" :visible.sync="dialogVisible" width="1000px">
      <div class="preview">
        <iframe
          id="iframe"
          :src="ifrSrc"
          frameborder="0"
          scrolling="no"
          v-if="dialogVisible"
          @load="iframeLoad"
          width="375px"
          :height="ifrHeight"
        ></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { company, projectV2, checkQuestionnaireIsAlikeAjax } from '@/api/ajax';
import updateQualificationProof from '../../../update-qualification-proof/update-qualification-proof';
import { moneyInt, moneyComplete } from '@/tools/money';
import QRCode from 'qrcode';
import Config from '@/config/index';
import addEdit from '@/page/project-classify/src/mixins/add-edit';
import { mapActions } from 'vuex';

export default {
  name: 'survey',
  mixins: [addEdit],
  components: { updateQualificationProof },
  data() {
    const checkUrl = (rule, value, callback) => {
      if (!value) {
        callback(new Error('链接地址不能为空'));
      } else if (!/https:\/\/jinshuju.net/.test(this.ruleForm.jsjUrl)) {
        callback(new Error('链接格式不正确'));
      } else {
        callback();
      }
    };
    return {
      //任务提交时间显示
      TaskSubmissionTimeisDisplayed: {
        isTaskSubmitTime: 1,
        projectExtendQues: {
          cso: 0,
          industry: 0,
          oss: 0,
          showFormatTime: ''
        }
      },
      //显示时间格式
      displayFormat: [
        {
          label: '年-月-日',
          value: 'yyyy-MM-dd'
        },
        {
          label: '年-月-日-时分秒',
          value: 'yyyy-MM-dd HH:mm:ss'
        },
        {
          label: '年-月',
          value: 'yyyy-MM'
        }
      ],
      reportValue: 0,

      ifrSrc: '',
      ifrHeight: '800px', // iframe 高度
      dialogVisible: false, // 是否显示预览

      searchAjax: company.list,

      sonProjectName: '',
      photoRule: {
        photoGraph: true,
        photoLibrary: true
      },
      prop: {
        label: 'enterpriseName',
        code: 'id'
      },
      defaultObj: {
        enterpriseName: '',
        id: ''
      },
      dcwjUrlImg: '', // 如果存在 则说明已填写链接
      ruleForm: {
        // certificationClassifyList: [],
        // isNeedCertification: 1,
        enterpriseName: '',
        industryEnterpriseId: '',

        projectNo: '',

        jsjUrl: '',
        questionnaireId: '', // 问卷ID

        picUploadRule: 1,
        tmQuesNameType: 0, //姓名题语言类型 1:中文 2:英文
        tmQuesNameRule: 0 //姓名题脱敏规则 1：部分隐藏  2:字母缩写  3:CRF四字缩写  4:不处理 5:四字补齐
      },
      // 脱敏部分，因为 目标姓名脱敏用的同一个值，但需求要分开处理默认值。
      tmForm: {
        tmQuesNameRule1: 0,
        tmQuesNameRule2: 0
      },
      // 校验
      rules: {
        tmExecuteNameRule: [
          {
            required: true,
            message: '请选择姓名题脱敏规则',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (+value === 0) {
                callback(new Error('请选择姓名题类型'));
              } else {
                callback();
              }
            }
          }
        ],
        // 姓名题类型
        tmQuesNameType: [
          {
            required: true,
            message: '请选择姓名题输入类型',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (+value === 0) {
                callback(new Error('请选择姓名题类型'));
              } else {
                callback();
              }
            }
          }
        ],
        // 姓名题脱敏规则
        tmQuesNameRule: [
          {
            required: true,
            message: '请选择姓名题脱敏规则',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (+value === 0) {
                callback(new Error('请选择姓名题脱敏规则'));
              } else {
                callback();
              }
            }
          }
        ],
        picUploadRule: [
          {
            required: true,
            message: '请选择上传图片方式',
            trigger: 'blur'
          }
        ],

        jsjUrl: [
          {
            required: true,
            validator: checkUrl,
            trigger: 'blur'
          }
        ],

        industryEnterpriseId: [
          {
            required: true,
            message: '请选择企业',
            trigger: 'blur'
          }
        ]
      }
    };
  },

  methods: {
    ...mapActions(['syncProjectInfo']),
    finishSubmitFn(type, noAutoReload = false) {
      return new Promise((resolve, reject) => {
        this.$checkQuestionnaireIsAlike({
          projectId: this.projectId,
          projectType: this.projectType,
          callback: isConfirm => {
            if (!isConfirm) {
              //问卷重复弹窗点击取消
              this.$refs.submitVerifyAndNextBtn.loading = false;
              return;
            }
            this.addEditMixin_finishSubmit
              .call(this, type, noAutoReload)
              .then(() => {
                resolve('submit_success');
              })
              .catch(() => {
                reject('submit_error');
              });
          }
        });
      });
    },
    addEditMixin_finishSubmit(type, noAutoReload = false) {
      //审核提交
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            if (this.ruleForm.questionnaireId) {
              this.$confirm(
                this.hasIndustry
                  ? '请您确认提交当前信息至后台审核，审核通过且待甲方确认无误后您将可以继续执行项目。'
                  : '请您提交当前信息至后台审核，审核通过后您将可以继续执行项目。',
                '提示',
                {
                  confirmButtonText: '确认提交',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
              )
                .then(() => {
                  projectV2
                    .submitProjectAudit({
                      ...this.ruleForm,
                      csoPrice: moneyComplete(this.ruleForm.csoPrice),
                      price: moneyComplete(this.ruleForm.price),
                      type: type
                    })
                    .then(() => {
                      resolve('submit_success');
                      sessionStorage.removeItem(`${this.projectId}-detail`);
                      this.$message({
                        type: 'success',
                        message: '已提交审核',
                        onClose: function() {
                          !noAutoReload && window.location.reload();
                        }
                      });
                    })
                    .catch(() => {
                      reject('submit_error');
                    });
                })
                .catch(() => {
                  reject('submit_error');
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                });
            } else {
              reject('submit_error');
              this.$notify({
                title: '保存失败',
                message: '请先编辑问卷内容',
                type: 'error'
              });
            }
          } else {
            reject('submit_error');
            return false;
          }
        });
      });
    },

    toQuestion() {
      /*
        设置缓存，防止点击左侧菜单时重载edit组件
        当项目保存或离开页面时清除缓存
      */
      sessionStorage.setItem(
        `${this.projectId}-detail`,
        JSON.stringify(this.ruleForm)
      );
      this.$router.replace({
        name: 'questionEdit',
        query: { questionnaireId: this.ruleForm.questionnaireId }
      });
    },
    useqrcode() {
      let canvas = this.$refs.canvas;
      QRCode.toCanvas(canvas, this.dcwjUrlImg, error => {
        if (error) console.error(error);
        this.dcwjUrlImg = canvas.toDataURL('image/png', 1);
      });
    },
    lookewm() {
      this.$alert(
        `<img style="width:255px;height:255px;display:block;margin:auto" src="${this.dcwjUrlImg}" />`,
        ' ',
        {
          dangerouslyUseHTMLString: true,
          closeOnPressEscape: true,
          confirmButtonText: '关 闭',
          showConfirmButton: false,
          closeOnClickModal: true,
          showClose: true
        }
      ).catch(() => {});
    },

    addEditMixin_submitForm(formName) {
      if (!this.ruleForm.questionnaireId) {
        this.$notify({
          title: '保存失败',
          message: '请先编辑问卷内容',
          type: 'error'
        });
        return false;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let cbEvent = () => {
            delete this.ruleForm['certificationClassifyList'];
            projectV2
              .addUpdateProjectV2({
                ...this.ruleForm,
                csoPrice: moneyComplete(this.ruleForm.csoPrice),
                price: moneyComplete(this.ruleForm.price)
              })
              .then(() => {
                this.$notify({
                  title: '成功',
                  message: '保存成功',
                  type: 'success'
                });
                this.$emit('resetRuleForm', this.ruleForm);
                sessionStorage.removeItem(`${this.projectId}-detail`);
                this.resetForm();
              });
          };
          if (this.priceFlag == false) {
            this.makeSureEvent(cbEvent);
          } else {
            cbEvent();
          }
        } else {
          return false;
        }
      });
    },
    iframeLoad() {
      this.$nextTick(() => {
        // let ifrDom = document.getElementById('iframe');
        // setTimeout(() => {
        //   this.ifrHeight =
        //     ifrDom.contentWindow.document.documentElement.scrollHeight + 'px';
        // }, 1500);
      });
    },
    openPreview() {
      this.ifrSrc = this.surveyUrl;
      this.dialogVisible = true;
    }
  },
  computed: {
    surveyUrl() {
      return `${Config.webViewUrl}${Config.webPath}/survey?projectId=${this.ruleForm.id}&projectType=${this.ruleForm.projectType}&userId=7&previewFlag=2&platformType=cso`;
    }
  },
  watch: {
    // 姓名题脱敏 语言类型
    'ruleForm.tmQuesNameType': {
      handler: function(v, oldV) {
        if (+v === +oldV) return;
        if (+oldV === 0) {
          if (+v === 1) {
            if (![1, 2, 3, 4].includes(+this.ruleForm.tmQuesNameRule)) {
              this.tmForm.tmQuesNameRule1 = 1;
              this.ruleForm.tmQuesNameRule = 1;
            }
          }
          if (+v === 2) {
            if (![3, 4].includes(+this.ruleForm.tmQuesNameRule)) {
              this.tmForm.tmQuesNameRule2 = 4;
              this.ruleForm.tmQuesNameRule = 4;
            }
          }
        } else {
          if (+v === 1) {
            this.tmForm.tmQuesNameRule1 = 1;
            this.ruleForm.tmQuesNameRule = 1;
          }
          if (+v === 2) {
            this.tmForm.tmQuesNameRule2 = 4;
            this.ruleForm.tmQuesNameRule = 4;
          }
        }
      }
    },
    //姓名题 中文脱敏规则
    'tmForm.tmQuesNameRule1': {
      handler: function(v) {
        this.ruleForm.tmQuesNameRule = v;
      }
    },
    //姓名题 英文脱敏规则
    'tmForm.tmQuesNameRule2': {
      handler: function(v) {
        this.ruleForm.tmQuesNameRule = v;
      }
    },
    'ruleForm.isQuesNameRule': {
      handler: function(v) {
        if (+v === 0) {
          this.ruleForm.tmQuesNameRule = 0;
          this.ruleForm.tmQuesNameType = 0;
        }
      }
    },
    photoRule: {
      handler(v) {
        let pickUpload = null;
        //全选
        if (v.photoGraph && v.photoLibrary) {
          pickUpload = 1;
        }
        //拍照
        if (v.photoGraph && !v.photoLibrary) {
          pickUpload = 2;
        }
        //图库
        if (!v.photoGraph && v.photoLibrary) {
          pickUpload = 3;
        }
        this.ruleForm.picUploadRule = pickUpload;
      },
      deep: true
    },
    'ruleForm.picUploadRule': {
      handler(v) {
        if (+v === 1) {
          this.photoRule.photoGraph = true;
          this.photoRule.photoLibrary = true;
        }
        if (+v === 2) {
          this.photoRule.photoGraph = true;
          this.photoRule.photoLibrary = false;
        }
        if (+v === 3) {
          this.photoRule.photoGraph = false;
          this.photoRule.photoLibrary = true;
        }
      },
      deep: true
    }
  },
  async created() {
    window.onmessage = ({ data }) => {
      if (data && data.code === 'iframeHeight' && data.value) {
        this.ifrHeight = `${data.value}px`;
      }
    };

    const data = await this.addEditMixin_init();
    let {
      tXcxProject,
      tDoctorProject,
      sonProjectName,
      taskSumCount,
      finishSumCount
    } = data;

    this.sonProjectName = sonProjectName == '全部' ? '' : sonProjectName;
    let project = tXcxProject || tDoctorProject;
    project.questionnaireTitle = `问卷标题：${project.questionnaireTitle ||
      ''}`;

    // 如果 有姓名题脱敏规则
    if (+project.isQuesNameRule !== 0) {
      // 没有值 设置默认值
      if (+project.tmQuesNameType === 0) {
        this.tmForm.tmQuesNameRule1 = 1; // 部分隐藏
        project.tmQuesNameType = 1; // 类型中文
        project.tmQuesNameRule = 1; // 部分隐藏
      } else {
        // 有值 分别赋值给 组件绑定的值
        if (+project.tmQuesNameType === 1) {
          // 中文
          this.tmForm.tmQuesNameRule1 = project.tmQuesNameRule;
        }
        if (+project.tmQuesNameType === 2) {
          // 英文
          this.tmForm.tmQuesNameRule2 = project.tmQuesNameRule;
        }
      }
    }

    Object.assign(this.ruleForm, project);

    this.ruleForm = Object.assign({}, this.ruleForm, {
      taskSumCount,
      finishSumCount
    });
    this.ruleForm.picUploadRule = this.ruleForm.picUploadRule || 1;
    this.ruleForm.isNeedCertification = this.homeProject.isNeedCertification;

    this.dcwjUrlImg = project.jsjUrl;
    if (project.jsjUrl) {
      this.$nextTick(() => {
        this.useqrcode();
      });
    }
    if (project.questionnaireId) {
      // 有问卷的时候，检查重合度
      checkQuestionnaireIsAlikeAjax({
        projectId: this.projectId,
        projectType: this.projectType
      }).then(({ data: { data } }) => {
        this.reportValue = data;
      });
    }
    this.ruleForm.certificationClassifyList = this.homeProject.certificationClassifyList;
    this.$emit('resetRuleForm', this.ruleForm);
    const noCacheData = {
      isQuesNameRule: project.isQuesNameRule,
      tmQuesNameType: project.tmQuesNameType,
      tmQuesNameRule: project.tmQuesNameRule
    };

    /*
            当点击编辑问卷时设置缓存
            优先使用缓存，离开页面或保存后清除
          */
    if (sessionStorage.getItem(`${this.projectId}-detail`)) {
      const cacheData = JSON.parse(
        sessionStorage.getItem(`${this.projectId}-detail`)
      );
      this.ruleForm = {
        ...cacheData
      };
      // 设置问卷ID，解决第一次编辑项目时，再编辑问卷后sessionStorage中不存在问卷ID
      this.ruleForm.questionnaireId = tXcxProject.questionnaireId;
    }
    this.ruleForm = {
      ...this.ruleForm,
      ...noCacheData
    };
    //任务提交时间显示
    const reqs = await this.syncProjectInfo();
    this.TaskSubmissionTimeisDisplayed.isTaskSubmitTime = reqs.isTaskSubmitTime;
    this.$set(
      this.TaskSubmissionTimeisDisplayed,
      'projectExtendQues',
      reqs.projectExtendQues
    );
  }
};
</script>
<style lang="scss" scoped>
>>> .el-radio-group {
  display: flex;
  align-items: center;
}

#canvas {
  display: none;
  width: 255px;
  height: 255px;
}
.preview {
  width: 375px;
  height: 550px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: auto;
}
.xrk-project-footer {
  z-index: 999;
}
</style>
